import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {getOrCreateOfferListingAmplitudeItemListId} from "./offer_listing_amplitude_item_list_id";

export interface GetOfferListingAmplitudeItemListNameParams {
    listingTitle: string;
    isPromotionsTab: boolean;
    hasPromotionTabs: boolean;
    latestQuery: IOfferListLatestQuery;
}

export const getOfferListingAmplitudeItemListName = (
    listingTitle: string,
    options: {isPromotionsTab: boolean; hasPromotionTabs: boolean}
): string | string[] => {
    const normalizedListingTitle = listingTitle.trim();

    if (!options.hasPromotionTabs) {
        return normalizedListingTitle;
    }

    const tabLabel = options.isPromotionsTab ? OFFER_LISTING_PROMOTION_TAB_LABELS.promotions : OFFER_LISTING_PROMOTION_TAB_LABELS.all;

    return normalizedListingTitle ? [tabLabel, normalizedListingTitle] : [tabLabel];
};

export const getOfferListingAmplitudeItemListContext = (params: GetOfferListingAmplitudeItemListNameParams): IAmplitudeItemListContext => ({
    itemListId: getOrCreateOfferListingAmplitudeItemListId(params.latestQuery),
    itemListName: getOfferListingAmplitudeItemListName(params.listingTitle, {
        isPromotionsTab: params.isPromotionsTab,
        hasPromotionTabs: params.hasPromotionTabs
    })
});
import {IAmplitudeItemListContext} from "../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LABELS} from "../constants/offer_listing_promotion_tabs";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";
import {getOrCreateOfferListingAmplitudeItemListId} from "./offer_listing_amplitude_item_list_id";

export interface GetOfferListingAmplitudeItemListNameParams {
    listingTitle: string;
    isPromotionsTab: boolean;
    hasPromotionTabs: boolean;
    latestQuery: IOfferListLatestQuery;
}

export const getOfferListingAmplitudeItemListName = (
    listingTitle: string,
    options: {isPromotionsTab: boolean; hasPromotionTabs: boolean}
): string | string[] => {
    const normalizedListingTitle = listingTitle.trim();

    if (!options.hasPromotionTabs) {
        return normalizedListingTitle;
    }

    const tabLabel = options.isPromotionsTab ? OFFER_LISTING_PROMOTION_TAB_LABELS.promotions : OFFER_LISTING_PROMOTION_TAB_LABELS.all;

    return normalizedListingTitle ? [tabLabel, normalizedListingTitle] : [tabLabel];
};

export const getOfferListingAmplitudeItemListContext = (params: GetOfferListingAmplitudeItemListNameParams): IAmplitudeItemListContext => ({
    itemListId: getOrCreateOfferListingAmplitudeItemListId(params.latestQuery),
    itemListName: getOfferListingAmplitudeItemListName(params.listingTitle, {
        isPromotionsTab: params.isPromotionsTab,
        hasPromotionTabs: params.hasPromotionTabs
    })
});
